export const assembledAccount = response => response.data.success;
export const assembledError = (error) => {
  if (error.response.data.data) {
    return error.response.data.data.errors[0].description;
  }
  return '';
};
